/* eslint-disable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */
import { useEffect, useRef, useState, useCallback } from 'react'

type Props = {
  value: any
  defaultValue: any
}

export default function useControlled({ value: controlled, defaultValue }: Props): [any, (newValue: any) => void] {
  const { current: isControlled } = useRef(controlled !== undefined)
  const [valueState, setValue] = useState(defaultValue)
  const value = isControlled ? controlled : valueState

  if (process.env.NODE_ENV !== 'production') {
    useEffect(() => {
      if (isControlled !== (controlled !== undefined)) {
        console.error(
          [
            'Elements should not switch from uncontrolled to controlled (or vice versa).',
            'More info: https://fb.me/react-controlled-components',
          ].join('\n'),
        )
      }
    }, [controlled])

    const { current: defaultProp } = useRef(defaultValue)

    useEffect(() => {
      if (defaultValue !== defaultProp) {
        console.error('A component is changing the default value of an uncontrolled element after being initialized.')
      }
    }, [JSON.stringify(defaultValue)])
  }

  const setValueIfUncontrolled = useCallback((newValue: any) => {
    if (!isControlled) {
      setValue(newValue)
    }
  }, [])

  return [value, setValueIfUncontrolled]
}
